import { FunctionComponent, useEffect, useMemo } from "react";
import "@rmwc/select/styles";
import { Select } from "@rmwc/select";
import style from "./Select.module.scss";

type ownProps = {
  title?: string;
  name?: string;
  className?: string;
  wrapperClassName?: string;
  label: string;
  onChange: (e: React.FormEvent<HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLSelectElement, Element>) => void;
  options: Array<string>;
  defaultValue?: string;
  errorMsg?: string;
  disabled?: boolean;
};

const SelectComponent: FunctionComponent<ownProps> = (props: ownProps) => {
  const {
    title,
    name,
    className = "",
    wrapperClassName = "",
    label,
    options,
    defaultValue,
    errorMsg,
    disabled,
  } = props;
  const invalid = useMemo(() => {
    return !!errorMsg;
  }, [errorMsg]);
  return (
    <div className={`${style.SelectComponent} ${wrapperClassName}`}>
      {title && <p className="mb-4">{title}</p>}
      <Select
        invalid={invalid}
        name={name}
        label={label}
        enhanced
        options={options}
        value={defaultValue}
        onChange={(e) => props.onChange(e)}
        onBlur={(e) => {
          props.onBlur && props.onBlur(e);
        }}
        className={className}
        disabled={disabled}
      />
      {<p className={style.errorMsg}>{invalid && errorMsg ? errorMsg : ""}</p>}
    </div>
  );
};

export { SelectComponent, SelectComponent as default };
